import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, ArrowRight, ShieldCheck, Eye, EyeOff } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { ADMIN_CREDENTIALS } from "../../mock/mock";
import { setAuthed } from "../../lib/adminAuth";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { LanguageSwitcher } from "../../components/public/Header";

const AdminLogin = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.login(username, password);
      setAuthed(true);
      navigate("/admin");
    } catch (err) {
      setError("Kullanıcı adı veya şifre hatalı");
    }
  };

  return (
    <div className="min-h-screen flex bg-neutral-950 text-white">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-12 relative overflow-hidden bg-gradient-to-br from-indigo-700 to-violet-700">
        <div className="absolute -top-20 -end-20 w-96 h-96 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-24 -start-16 w-96 h-96 rounded-full bg-black/20 blur-3xl" />
        <div className="relative flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
            <span className="text-indigo-700 font-display font-extrabold text-xl">i</span>
          </div>
          <span className="font-display font-extrabold text-2xl">intro</span>
        </div>
        <div className="relative">
          <h1 className="font-display font-extrabold text-4xl leading-tight">Yönetim Paneli</h1>
          <p className="mt-4 text-white/80 text-lg max-w-sm">Sitenin her ayrıntısını tek bir yerden yönet — uzmanlar, kategoriler, içerik ve diller.</p>
          <div className="mt-8 flex items-center gap-2 text-white/70 text-sm">
            <ShieldCheck className="w-5 h-5" /> Güvenli ve şık deneyim
          </div>
        </div>
        <div className="relative text-white/50 text-sm">© {new Date().getFullYear()} intro · demo</div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex flex-col">
        <div className="flex justify-end p-6">
          <div className="text-neutral-900 bg-white/90 rounded-full"><LanguageSwitcher compact /></div>
        </div>
        <div className="flex-1 flex items-center justify-center px-6 pb-16">
          <div className="w-full max-w-sm">
            <div className="lg:hidden flex items-center gap-2 mb-8">
              <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
                <span className="text-neutral-900 font-display font-extrabold text-xl">i</span>
              </div>
              <span className="font-display font-extrabold text-2xl">intro</span>
            </div>
            <h2 className="font-display font-extrabold text-3xl">{t("admin.login")}</h2>
            <p className="text-neutral-400 mt-2">admin / admin123</p>

            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <label className="text-sm font-medium text-neutral-300">{t("admin.username")}</label>
                <div className="mt-1.5 flex items-center gap-2 bg-neutral-900 border border-neutral-800 rounded-2xl px-4 focus-within:border-indigo-500 transition">
                  <User className="w-4 h-4 text-neutral-500" />
                  <input value={username} onChange={(e) => setUsername(e.target.value)} className="flex-1 bg-transparent outline-none py-3.5 text-white" placeholder="admin" />
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-neutral-300">{t("admin.password")}</label>
                <div className="mt-1.5 flex items-center gap-2 bg-neutral-900 border border-neutral-800 rounded-2xl px-4 focus-within:border-indigo-500 transition">
                  <Lock className="w-4 h-4 text-neutral-500" />
                  <input type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 bg-transparent outline-none py-3.5 text-white" placeholder="••••••••" />
                  <button type="button" onClick={() => setShow((s) => !s)} className="text-neutral-500 hover:text-white">
                    {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              {error && <p className="text-rose-400 text-sm">{error}</p>}
              <Button type="submit" className="w-full h-12 rounded-2xl bg-indigo-600 hover:bg-indigo-500 text-white font-semibold text-base">
                {t("admin.signIn")} <ArrowRight className="w-4 h-4 ms-1 rtl:rotate-180" />
              </Button>
            </form>
            <button onClick={() => navigate("/")} className="mt-6 text-sm text-neutral-500 hover:text-neutral-300">← Siteye dön</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
